module.exports = {
    "Bloodhound": require("typeahead.js/dist/bloodhound.js"),
    "loadjQueryPlugin": function() {require("typeahead.js");}
};
